<template>
  <div class="pay-way">
    <h2
      class="block-title"
      v-t="'order.payWay'"
    />
    <div class="switch-way">
      <mm-tabs 
        v-if="canPay" 
        v-model="way"
      >
        <template v-if="isAliUser">
          <mm-tab name="4">
            <div slot="label">
              <div class="switch-item">
                <svg class="xm-icon">
                  <use xlink:href="#icon-alibaba" />
                </svg>
                <i class="iconfont icon-selected" />
                <span
                  v-t="'order.alibabaShop'"
                />
                <span>
                  ：{{ orderInfo.member_id || orderInfo.ali_cgs }}
                </span>
              </div>
              <div class="alibaba-login">
                <span
                  v-t="'order.alibabaLogin'"
                />
                <a
                  target="_blank"
                  :href="AliUrl"
                  v-t="'order.alibabaPay'"
                />
              </div>
            </div>
          </mm-tab>
        </template>
        <template v-if="isOnlyDollarPay&&!isAliUser">
          <!-- 非人命币订单只可以美元转账 -->
          <mm-tab name="3">
            <div slot="label">
              <div class="switch-item">
                <svg class="xm-icon">
                  <use xlink:href="#icon-union_pay" />
                </svg>
                <i class="iconfont icon-selected" />
                {{ $t('order.unionDollar') }}
              </div>
              <span
                class="warn"
                v-t="'order.dollarTips'"
              />
            </div>
          </mm-tab>
        </template>
        <template v-if="!isOnlyDollarPay&&!isAliUser">
          <!-- 人民币订单可以支付宝和转账付款 -->
          <mm-tab name="1">
            <div
              class="switch-item"
              slot="label"
            >
              <svg class="xm-icon">
                <use xlink:href="#icon-mobile_pay" />
              </svg>
              <i class="iconfont icon-selected" />
              {{ isWx ? $t("order.mobile") : $t("order.zhifubao") }}
            </div>
          </mm-tab>
          <mm-tab name="2">
            <div
              class="switch-item"
              slot="label"
            >
              <svg class="xm-icon">
                <use xlink:href="#icon-union_pay" />
              </svg>
              <i class="iconfont icon-selected" />
              {{ $t('order.union') }}
            </div>
          </mm-tab>
        </template>
      </mm-tabs>
      <div
        v-else
        class="pay-sync-tips"
      >
        {{ $t('order.waitPaySync') }}
      </div>
    </div>
    <component
      v-if="canPay && !isAliUser"
      :key="way"
      :is="payWayCom"
      :mold="way"
      :is-google-or-market="includeGoogleOrMarket"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import {
    PAY_TYPE_ALI,
    PAY_TYPE_UNION,
    PAY_TYPE_UNION_DOLLAR,
    PAY_TYPE_ALIBABA,
  } from '@utils/constants'
  import Mobile from './PayWayStrategy/Mobile'
  import Union from './PayWayStrategy/Union'
  import {
    PRODUCT_ID_GOOGLEADS,
    PRODUCT_ID_MARKETING,
  } from '@utils/constants'

  const AliUrl = 'https://business.alibaba.com/customer/proposalAndOrderList'
  export default {
    name: 'OrderPayWay',
    props:{
      orderInfo:{
        type:Object,
        default:()=>({})
      }
    },
    data () {
      return {
        AliUrl,
        way: `${PAY_TYPE_ALI}`,
        isOnlyDollarPay: false
      }
    },
    watch: {
      currency: {
        handler (value) {
          // 非人民币订单，只可以美元转账付款
          this.isOnlyDollarPay = value !== '￥'
          this.way = this.isAliUser
          ? `${PAY_TYPE_ALIBABA}`
          : this.isOnlyDollarPay
          ? `${PAY_TYPE_UNION_DOLLAR}`
          : `${PAY_TYPE_ALI}`;
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters('order', ['currency']),
      ...mapGetters('main', ['isAliUser']),
      canPay() {
        return this.orderInfo.allow_pay
      },
      payWayCom () {
        const payWayMap = {
          [PAY_TYPE_ALI]: Mobile,
          [PAY_TYPE_UNION]: Union,
          [PAY_TYPE_UNION_DOLLAR]: Union
        }
        return payWayMap[this.way]
      },
      includeGoogleOrMarket() {
        return this.orderInfo.product_list.some(item =>
          [PRODUCT_ID_GOOGLEADS, PRODUCT_ID_MARKETING].includes(item.product_id)
        );
      },
      isWx(){
        return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      },
    },
    methods: {
      handleSwitch (value) {
        this.way = `${value}`
      }
    },
    components: {
      Mobile,
      Union
    }
  }
</script>
<style lang="scss">
  .pay-way{
    .mm-tabs-active-bar,
    .mm-tabs-nav-wrap::after{
      display: none
    }
    .mm-tabs-item{
      padding: 0;
      @include layout--mobile{
        display: block;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .alibaba-login{
        font-size: 14px;
        color: #2A2A2A;
        span{
          font-weight: bold;
          margin-right: 5px;
        }
      }
      &.mm-tabs-item--active{
        .switch-item{
          border-color: $base-color;
          .pay-icon{
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
        .icon-selected{
          display: block;
          color: #0884F3;
        }
      }
    }
    
  }
</style>

<style lang="scss" scoped>
  .pay-way{
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 2px solid #D9D9D9;
  }
  .switch-way{
    display: flex;
    margin-top: 20px;
    user-select: none;
  }
  .pay-sync-tips{
    font-size: 14px;
    line-height: 22px;
    color: #909090;
  }
  .switch-item{
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 26px;
    margin-right: 18px;
    font-size: 18px;
    color: #2A2A2A;
    border: 1px solid #979797;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
    &.active{
      border-color: #0884F3;
      .icon-selected{
        display: block;
        color: #0884F3;
      }
    }
    .icon{
      margin-right: 8px;
    }
    .icon-selected{
      position: absolute;
      right: -1px;
      bottom: -1px;
      display: none;
      width: 17px;
      height: 17px;
      margin: 0;
      line-height: 1;
    }
  }
  .warn{
    width: auto;
    font-size: 12px;
    color: #E95B5B;
  }
</style>
